import {
  QuestionReviewReviewerSection,
  QuestionReviewTaskInformation,
  TaskQuestionDetailsSection,
} from '@exam-management/new-question-review-task-details';
import { Flex } from '@shared/components';

export default function QuestionReviewTaskDetailsPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        width: '100%',
        bgcolor: theme.palette.grey[50],
        p: theme.spacing(6),
      })}
    >
      <QuestionReviewTaskInformation />
      <TaskQuestionDetailsSection />
      <QuestionReviewReviewerSection />
    </Flex>
  );
}
